import { Country } from "./country.model";

export class LocationDetailsModel {
  ldId: string = null;
  ldSupplierId : string = null;
  ldAddress1: string = null;
  ldAddress2: string = null;
  ldLongitude: number = null;
  ldLatitude: number = null;
  ldPostalCode: string = null;
  ldTelephone: string = null;
  ldFax: string = null;
  ldInformation = [];
  ldCity: string = null;
  ldCountry: Country = new Country();
  ldComment: string = null;
  ldLocationTypeId: string = null;
  ldName: string = null;
  ldType: string = null;
  ldRelationNumber: string = null;
  ldEmail: string = null;
  ldIcon: string = null;
  ldLocationName: string = null;
  ldAssignmentId: string = null;
  locationName:string;
}
 